import type { ElplanInfoTagForDate } from 'api/elplan/elplan.types'
import { getBidTagsInBidInputOrder } from 'helpers/elplan.helper/bidTagOrder.helper'
import type { BidProductionConsumption, BidTagSelectionGroup, BidTagSelectionOption } from './DayAheadBidEditor.types'

export function getBidTagSelectionOptions(
  selectableTags: ElplanInfoTagForDate[],
  selectedProductionConsumption: BidProductionConsumption
): BidTagSelectionGroup[] {
  const selectedTags = getBidTagsInBidInputOrder(selectableTags, selectedProductionConsumption)

  const buyOptions: BidTagSelectionOption[] = selectedTags
    .filter((tag) => tag.buy_sell === 'buy')
    .map((tag) => ({
      id: tag.id,
      tagKey: tag.tag_key,
      disabled: !tag.available,
    }))

  const sellOptions: BidTagSelectionOption[] = selectedTags
    .filter((tag) => tag.buy_sell === 'sell')
    .map((tag) => ({
      id: tag.id,
      tagKey: tag.tag_key,
      disabled: !tag.available,
    }))

  return [
    { buySell: 'buy', options: buyOptions },
    { buySell: 'sell', options: sellOptions },
  ]
}

export function findTagById(
  selectableTags: ElplanInfoTagForDate[],
  tagId: number | null | undefined
): ElplanInfoTagForDate | undefined {
  if (!tagId) {
    return undefined
  }

  return selectableTags.find((tag) => tag.id === tagId)
}

export function getBidTagProductionConsumption(
  tagsForDate: ElplanInfoTagForDate[],
  tagId: number | null | undefined
): BidProductionConsumption | undefined {
  return findTagById(tagsForDate, tagId)?.production_consumption
}
